import { useParams } from '@tanstack/react-router';
import { IFlowRouteParams } from '_/common/routes/routes.types';
import { useOrganization } from '_/contexts/OrganizationContext';
import { getFlowUrl } from '_/features/flows/common/utils/flowUrl.utils';

const useFlowUrl = (suffix = ''): string => {
  const params = useParams({ strict: false }) as Partial<IFlowRouteParams>;
  const projectSlug = params.projectSlug || '';
  const flowSlug = params.flowSlug || '';
  const { selectedOrgSlug } = useOrganization();
  return getFlowUrl({
    orgSlug: selectedOrgSlug || '',
    projectSlug: projectSlug,
    flowSlug: flowSlug,
    suffix: suffix,
  });
};

export default useFlowUrl;
